






































import Mapbox from 'mapbox-gl';
import Vue from 'vue'
import * as mapboxgl from 'mapbox-gl'
import { MglMap, MglNavigationControl,  MglGeojsonLayer,/*MglRasterLayer*/ } from 'vue-mapbox';
import {mapState} from 'vuex'
import * as types from '../store/types'
import * as actions from '../store/actions'
import * as fields from '../store/fields'
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import MapboxDraw from '@mapbox/mapbox-gl-draw'
import bbox from '@turf/bbox'
import intersect from '@turf/intersect'
import {polygon} from '@turf/helpers'
import CCMapLayerButtons from './CCMapLayerButtons.vue'

const catchmentKeyToLabel = (key: string) => {
  const map: Record<string,string> = {'chd__05'  : 'Children under 5',
    'chl__01'  : 'Children under 1',
    'lv_brth'  : 'Live Births',
    'ttl_ppl' : 'Total Population',
    'wmn_chl' : 'Woman of Childbearing Age'}
  return map[key] ?? key
}


export default Vue.extend({
  name: 'Map',
  components: {
    CCMapLayerButtons,
    MglMap,
    MglNavigationControl,
    MglGeojsonLayer,
  },
  data() {
    return {
      accessToken: process.env?.VUE_APP_MAPBOX_ACCESS_TOKEN ?? "NULL_MAPBOX_ACCESS_TOKEN", // your access token. Needed if you using Mapbox maps
      // coordinates: [-15.3101, 13.4432], GAMBIA
      // coordinates: [38.7578, 8.9806],
      mapStyle: process.env?.VUE_APP_MAPBOX_STYLE ?? "NULL_MAPBOX_MAP_STYLE", // your map style,
      zoom: 6,
      mapbox: null as any,
      populationFilter: null as any,
      popup: {
        data: {} as any,
        show: false,
        coordinates: [0,0],
        fields: [] as Array<any>,
        items: [] as Array<any>
      },
      hoverId: undefined as string|undefined,
      siteId: undefined as string|undefined,
      // center: [ 38.7578, 8.9806],
      // center: [ 38.7578,11.9806], //ethiopia
      center: [-72.28, 18.8712] //haiti
      // center: [-15.3101, 13.4432]
    };
  },

  computed: mapState({
    sources: (state: any) => (state.map.sources as Array<types.Schema$MapboxSource>),
    layers: (state: any) => (state.map.layers as Array<any>),
    sortedLayers: (state: any) => (state.map.layers.map((layer: any) => ({...layer})).sort((a: any,b: any) => a.label.localeCompare(b.label)) )
  }),

  watch: {
    sources(newSources, oldSources) {
      if (this.map && this.map.loaded()) {
        newSources.forEach((source) => {
          const {id, url, data, type} = source

          if (url) {
            //a  mapbox url
            this.map.addSource(id, {url,type})  
          } else {
            //a geojson url
            this.map.addSource(id, {data,type})  
          }
          
        })
      }
      
    }
  },


  methods: {
    async onMapLoaded({map,component}: any) {
      this.map = map
      // map.setFilter('hf_layer', ['in', ['get', 'Admin1'], ['Addis Ababa', 'Tigray']])
      this.draw = new MapboxDraw({
        boxSelect: true,
        controls: {
          point: true,
          'line_string': false,
          polygon: true,
          trash: true,
          'combine_features': false,
          'uncombine_features': false
        }
      })
      const store = this.$store
      map.addControl(this.draw, 'top-left')
      const drawHere = this.draw
      if (this.sources.length > 0) {
        this.sources.forEach((source) => {
          const {id,  url, data, type} = source

          if (url) {
            //a  mapbox url
            this.map.addSource(id, {url,type})  
          } else {
            //a geojson url
            this.map.addSource(id, {data,type})  
          }
          
        }) 
      }
      
      const onHealthFacilityClick = (e: any) => {
        const site = {...e.features[0].properties}


        let siteItems =  Object.entries(site)
          .map(([field,value]) => ({
            field: {...fields.populationFieldLookup(field)},
            value
          }))

        siteItems = [...siteItems, {field: { label: 'Long', visible: true},
          value: e.features[0].geometry.coordinates[0].toFixed(6)
        },
        {
          field: {label: 'Lat', visible: true},
          value: e.features[0].geometry.coordinates[1].toFixed(6)
        }
        ]


        this.$store.commit(actions.SET_SITE, {items: siteItems})
        this.$store.commit(actions.SET_TAB, 'site')
        this.$store.commit(actions.SHOW_DATA, true)
      }


      this.layers.filter((layer: any) => layer.cc_type === 'health_facility')
        .forEach((layer) => {
          map.on('click', layer.id, onHealthFacilityClick)
          map.on('mouseenter', layer.id, (e: any) => {
            map.getCanvas().style.cursor = 'pointer';
          })
          map.on('mouseleave', layer.id, (e: any) => {
            map.getCanvas().style.cursor = '';
          })
        })

      map.on('draw.create', (e: any) => {
        const data = drawHere.getAll()
        
        if(data.features.length > 0) {
          const box = bbox(data)
          
          const popFeatures = map.queryRenderedFeatures({
            layers: this.layers
              .filter(l => l.cc_type === 'pop_block')
              .map(l => l.id)
          })
          
          //TODO: move this to a separate function
          const geo = popFeatures[0]
            
          const selection = data.features[0]

          // const intersection = intersect(geo, selection);

          let fieldsToAggregate=null
          const aggregate = popFeatures
            .filter((popBlock: any) => popBlock.properties['gid_1'] || popBlock.properties['tot_pop']) //filter out empty blocks
            .filter((popBlock: any) => intersect(popBlock, selection) != null)
            .reduce((accumulator: any, curBlock: any, curIndex: number) => {
              //aggreate all fields of type 'number'
              if (fieldsToAggregate == null) {
                fieldsToAggregate = Object.entries(curBlock.properties)
                  .filter( ([field,value]) => typeof value == 'number')
                  .map(([field,value]) => field)
              }
              //aggregate
              fieldsToAggregate.forEach((property) => {
                  if (curBlock.properties[property]) {
                    accumulator[property] = curBlock.properties[property] + (accumulator[property] || 0)
                  }
                })
              return accumulator
            },{})

            //An ugly hack to get the field name right
          store.commit(actions.SET_POPULATION, {population: {totl_pp: aggregate.tot_pop}})
          store.commit(actions.SHOW_DATA, true)
          setTimeout(() => {store.commit(actions.SET_TAB, 'population')},100)
          
        }
      })
      // map.on('draw.selectionChange', function(e) {
        
      // })     
    },

    async onMouseMove({mapboxEvent, map}: any) {
      const point  = mapboxEvent.point

      const layers = this.layers.filter((layer) => layer.cc_type === 'catchment' || layer.cc_type === 'microplan' )
      const features  = map.queryRenderedFeatures(point, {
        layers: layers.map(l => l.id)
      })

      if(features.length > 0) {
        const layer = features[0].layer
        // const lineLayer = layer.
        const sourceLayer = layer['source-layer'] || undefined
        if(this.hoverId) {
          map.setFeatureState(
          { source: layer.source, sourceLayer,  id: this.hoverId },
          { hover: false }
          );
        }

        this.hoverId = features[0].id;
        map.setFeatureState(
        { source: layer.source, sourceLayer, id: this.hoverId },
        { hover: true }
        );
      }
    },


    async onMapClick({mapboxEvent, map}: any) {
      // const asyncActions  = event.component.actions 
      if (this.draw.getMode() == 'draw_polygon') {
        return;
      }
      const mode = this.draw.getMode()
      const point = mapboxEvent.point
      const features = map.queryRenderedFeatures(point,  {
        layers: this.layers
                  .filter((layer) => layer.cc_type === 'catchment' || layer.cc_type === 'microplan')
                  .map((layer) => layer.id)
        })

      if(features.length > 0) {
        //catchment info
        const catchmentFeature: any  = features.find((feature: any) => feature.sourceLayer === 'ctch') || {properties: {}}
        
        

        const catchmentItems = Object.entries(catchmentFeature.properties)
          .map(([field,value]: Array<any>) => ({
            field: {...fields.populationFieldLookup(field)}, 
            value: typeof value === 'number' ? (Math.floor(value)).toLocaleString() : value
            // value: value(isNaN(parseInt(value))) ? value : (Math.floor(value)+1).toLocaleString() 
          }))



        //get the site that corresponds with the catchment
        const siteId: number = catchmentFeature.properties['crssct_'] || "NO_SITE_ID_PROPERTY_FOUND"
        
        const siteSources = this.sources.filter((s) => s.cc_type === 'health_facility')
        const siteFeatures = siteSources.reduce((accumulator, source) => {
          const sites = map.querySourceFeatures(source.id, {
            filter: ['==', 'crssct_', siteId ]
          })
          accumulator = [...accumulator, ...sites]
          return accumulator
        }, [])
        

        const firstSiteFeature = siteFeatures[0] || {properties: {}}
        let siteItems =  Object.entries(firstSiteFeature.properties)
          .map(([field,value]) => ({field: 
            fields.populationFieldLookup(field),value}))

        siteItems = [...siteItems, {field: { label: 'Long', visible: true},
          value: firstSiteFeature.geometry.coordinates[0].toFixed(6)
        },
        {
          field: {label: 'Lat', visible: true},
          value: firstSiteFeature.geometry.coordinates[1].toFixed(6)
        }
        ]

        const microplanFeatures = map.queryRenderedFeatures(point, {
          layers: this.layers.filter((layer) => layer.cc_type === 'microplan')
            .map((layer) => (layer.id))
        }) || []
        
        
        
        
        const firstMicroplanFeature: any = microplanFeatures[0] || {properties:{}} 
        const microplanItems = Object.entries(firstMicroplanFeature.properties)
          .map(([field,value]: Array<any>)=> ({
            field: fields.populationFieldLookup(field),
            value: (Math.floor(value)+1).toLocaleString()}))

        //figure out which tab should be highlighted
        // TODO: fix this so MP takes precedence of Catchment
        const highestLayer = features[0]
        
        switch(highestLayer.sourceLayer) {
          case 'ctch':
            this.$store.commit(actions.SET_TAB, 'catchment')
            break
          case 'mp':
            this.$store.commit(actions.SET_TAB, 'microplan')
            break
        }
        console.log(firstSiteFeature)
        const name = firstSiteFeature.properties['NameLdr'] 
        //first update catchment
        this.$store.commit(actions.SET_DATA, {
          catchment: {
            items: catchmentItems
          },
          microplan: {
            items: microplanItems
          },
          site: {
            items: siteItems,
            name:  firstSiteFeature.properties['Localty'] || "",
            id: firstSiteFeature.properties['crssct_']
          }
        })

        if(this.siteId) {
          if(this.siteId == siteId) {
            this.siteId = "-1"
            // this.$store.commit(actions.SHOW_DATA, false)
          } else {
            this.$store.commit(actions.SHOW_DATA, true)
            this.siteId = siteId
          }
        } else {
          this.$store.commit(actions.SHOW_DATA, true)
          this.siteId = siteId
        }
        
      }

    }
    
  },

  created() {
    // We need to set mapbox-gl library here in order to use it in template
    this.mapbox = Mapbox;
    this.map = null;
  }
}) as any;
